export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const app_logo = require('../assets/image_logo.png')
export const background = require('../assets/backimage_.png');
export const viewa = require("../assets/view_B.png");
export const viewb = require("../assets/view_A.png");
export const home_screen = require('../assets/home_screen_.png')
export const imgBase = require('../assets/viewcircle_.png')
export const qrImg = require('../assets/group_3.png');
export const notFound = require('../assets/not_found.png');